
import * as types from './mutation-types.js'

import store from '../story/'



export default {

/*  async getCartlist({
    commit,
    state
  }) {
    let res = await getData.shoppingCartNum();
    commit(types.SAVE_CARTLIST, res.shoppingCartNum)
  }*/
  saveListPagePars: ({ commit },{path,pars}) => {
    commit('SAVE_LIST_PAGE_PARS',{ path,pars });

  },

}



// WEBPACK FOOTER //
// ./src/story/action.js